<ion-header>
  <ion-toolbar class="left-header-toolbar" [ngClass]="{ 'toolbar-android': isAndroid}">
    <ion-buttons class="start-slot" slot="start">
    </ion-buttons>

    <div class="searchbar-wrapper">
        <ion-searchbar [debounce]="300" placeholder="{{'HOME' | translate}}"></ion-searchbar>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
  <ind-section-header [isSkeleton]="true"></ind-section-header>
  <ng-container *ngFor="let i of [].constructor(numberOfSkeletonCardsToDisplay); let idx = index; trackBy: trackByIndex">
      <main-card [isSkeleton]="true"></main-card>
  </ng-container>
  </ion-list>
</ion-content>
